<template>
  <div id="setting">
    <div class="main">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin:10px 0">
      <el-breadcrumb-item :to="{ path: '/personal-center/store-manage' }">{{$t('store.store')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('storeSetting.storeStting')}}</el-breadcrumb-item>
      </el-breadcrumb>
    <p class="page-title">{{ $t('storeSetting.storeStting') }}</p>
    <div class="setting">
      <div class="store-title bg-white padding">
        <div style="width:130px">
          <img v-if="storeInfo.platformCode==='SP'" style="width:100%" src="@/assets/img/homePage/shopify.png" alt="" />
          <img v-if="storeInfo.platformCode==='DJ'" style="width:100%" src="@/assets/img/homePage/shoplazza.png" alt="" />
          <img v-if="storeInfo.platformCode==='SL'" style="width:100%" src="@/assets/img/homePage/shopline.png" alt=""/>
        </div>
        <div class="f">
          <div>
            <span class="label font">{{ $t('storeSetting.storeName') }}：</span>
            <span class="info font">{{ storeInfo.storeName }}</span>
          </div>
          <div style="margin-left:80px">
            <span class="label font">{{ $t('storeSetting.whetherToAuthorize') }}：</span>
            <span class="info font">{{
              storeInfo.authorizeStatus === 1? $t('store.authorized'): $t('store.unauthorized') }}</span>
          </div>
        </div>
        <div>
          <span class="label font">{{ $t('storeSetting.storeLink') }}：</span>
          <span class="info font">{{ storeInfo.storeUrl }}</span>
        </div>
      </div>

      <div class="padding bg-white product-rule_1">
        <el-checkbox v-model="storeInfo.isTax" :true-label='1' :false-label='0' class="title">{{  $t('storeSetting.taxRuleTitle')   }}</el-checkbox>
        <p class="label font">{{ $t('storeSetting.taxRuleTip') }}</p>
      </div>
      <div class="padding bg-white product-rule_1">
        <p class="title">{{ $t('storeSetting.productNationalRules') }}</p>
        <p class="label font">{{ $t('storeSetting.productNationalRulesTip') }}
          <el-select style="width:200px" v-model="storeInfo.defaultReceivingCountry" filterable :filter-method="value=> countryFilterMethod(value)"  @change="countrySelectChange">
            <el-option v-for="item in receivingCountryListFilter" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
          </el-select>
        </p>
      </div>

      <div class="product-rule_1 bg-white padding">
        <p class="title">{{ $t('storeSetting.productRules') }}</p>
        <p class="label font" style="padding-bottom:12px;">{{ $t('storeSetting.productRuleTip1') }}</p>
        <!-- <el-radio-group v-model="storeInfo.autoDeleteSoldOutSku">
          <el-radio :label="0">{{ $t('storeSetting.dontDealWidth1') }}</el-radio>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">{{ $t('storeSetting.productRuleYHint1') }}</div>
            <el-radio :label="1">{{ $t('storeSetting.productRuleY1') }}</el-radio>
          </el-tooltip>
        </el-radio-group> -->
        <el-checkbox v-model="storeInfo.isAutoInventory" :disabled="!!storeInfo.autoDeleteSoldOutSku">{{ $t('storeSetting.dontDealWidth1') }}</el-checkbox>
        <el-tooltip class="item" effect="dark" placement="bottom">
          <div slot="content">{{ $t('storeSetting.productRuleYHint1') }}</div>
          <el-checkbox v-model="storeInfo.autoDeleteSoldOutSku" @change="changeProductRules">{{ $t('storeSetting.productRuleY1') }}</el-checkbox>
        </el-tooltip>

        <p class="label" style="padding:20px 0;padding-right:44px;">{{ $t('storeSetting.productRuleYHint2') }}</p>
        <p class="label" style="padding-right:44px;">{{ $t('storeSetting.productRuleYHint3') }}</p>

        <p class="label" style="padding-right:44px;margin-top:20px;">{{ $t('storeSetting.productRuleYHint5') }}</p>
        <el-checkbox-group v-model="storeInfo.listingUpdateConfList" style="margin-top:12px;">
          <el-checkbox v-for="item in updateConfList" :disabled="item === 'Size Chart'" :key="item" :label="item"></el-checkbox>
          <!-- <el-checkbox :label="$t('storeSetting.changeField1')"></el-checkbox>
          <el-checkbox :label="$t('storeSetting.changeField2')"></el-checkbox>
          <el-checkbox :label="$t('storeSetting.changeField3')"></el-checkbox>
          <el-checkbox :label="$t('storeSetting.changeField4')"></el-checkbox>
          <el-checkbox :label="$t('storeSetting.changeField5')"></el-checkbox> -->
        </el-checkbox-group>
      </div>

      <div class="product-rule_2 bg-white padding">
        <p class="title">{{ $t('storeSetting.priceRules') }}</p>
        <el-tooltip class="item" effect="dark" content="Currency is automatically obtained from shopify store" placement="bottom-start">
          <i style="color:#747a87" class="iconfont iconhelp"></i>
        </el-tooltip>
        <span style="margin-left:5px" class="info font">{{ $t('storeSetting.storeCurrency') }}</span>
        <el-input v-model="storeInfo.currency" disabled class="margin-l input-currency" style="width:160px"></el-input>

        <div style="height:54px;width:800px">
          <el-checkbox v-model="storeInfo.isPrice" :true-label='1' :false-label='0' class="label font priceCheckbox">{{$t('storeSetting.originalPrice')}}</el-checkbox>
          <span class="font info" v-if="storeInfo.isPrice === 1">
            <span>{{ $t('storeSetting.productCost') }}</span>
            <!-- <span class="margin-l">×</span> -->
            <el-select v-model="storeInfo.priceRatioType" style="width:60px;margin-left:10px;">
              <el-option label="x" value="x"></el-option>
              <el-option label="+" value="+"></el-option>
            </el-select>
            <el-input-number v-model="storeInfo.priceRatio" class="margin-l" :min="0.1" :max="999" style="width:170px" :placeholder="storeInfo.priceRatioType === '+' ? $t('PersonalCenter.Store.SetStore.Profit') : $t('PersonalCenter.Store.SetStore.ProfitMargin')"></el-input-number>
            <!-- <span class="margin-l">{{$t('storeSetting.multiplier')}}</span> -->
            <span class="margin-l">+</span>
            <span class="margin-l">{{$t('storeSetting.shipping')}}</span>
            <span class="margin-l"> = </span>
            <span class="margin-l">{{ $t('storeSetting.originalPrice') }} </span>
          </span>
        </div>

        <div style="height:54px;width:800px">
          <el-checkbox v-model="storeInfo.isComparePrice" :true-label='1' :false-label='0' class="label font priceCheckbox">{{ $t('storeSetting.compareAtPrice') }}</el-checkbox>
          <span class="font info" v-if="storeInfo.isComparePrice === 1">
            <span>{{ $t('storeSetting.productCost') }}</span>
            <!-- <span class="margin-l">×</span> -->
            <el-select v-model="storeInfo.compareRatioType" style="width:60px;margin-left:10px;">
              <el-option label="x" value="x"></el-option>
              <el-option label="+" value="+"></el-option>
            </el-select>
            <el-input-number v-model="storeInfo.compareRatio" class="margin-l" :min="0.1" :max="999" style="width:170px" :placeholder="storeInfo.compareRatioType === '+' ? $t('PersonalCenter.Store.SetStore.Profit') : $t('PersonalCenter.Store.SetStore.ProfitMargin')"></el-input-number>
            <!-- <span class="margin-l">{{ $t('storeSetting.multiplier') }}</span> -->
            <span class="margin-l">+</span>
            <span class="margin-l">{{ $t('storeSetting.shipping') }}</span>
            <span class="margin-l"> = </span>
            <span class="margin-l">{{ $t('storeSetting.compareAtPrice') }}</span>
          </span><br />
        </div>
      </div>

      <div class="order-rules bg-white padding">
        <p class="title">{{ $t('storeSetting.orderRules') }}</p>
        <p class="label font">{{ $t('storeSetting.orderRulesTip1') }}</p>
        <el-radio-group class="font info" v-model="storeInfo.isDeliverMark">
          <el-radio :label="0">{{ $t('storeSetting.dontDealWidth') }}</el-radio>
          <el-radio :label="1">{{ $t('storeSetting.orderRulesY') }} <span v-if="storeInfo.isDeliverMark === 1 && storeInfo.platformCode === 'SP'" style="margin-left:10px;text-decoration:underline;" @click="jump">({{ $t('storeSetting.orderRulesYTip') }})</span> </el-radio>
        </el-radio-group>
        <p class="label font">{{ $t('storeSetting.orderRulesTip2') }}</p>
        <el-radio-group class="font info" v-model="storeInfo.isAutoPurchase">
          <el-radio :label="0">{{$t('storeSetting.orderRulesTip2N') }}</el-radio>
          <el-radio :label="1">{{   $t('storeSetting.orderRulesTip2Y') }}</el-radio>
        </el-radio-group>
        <p class="label font">{{ $t('PersonalCenter.Store.SetStore.DefaultShippingMethod') }}</p>
        <el-radio-group class="font info" v-model="storeInfo.shippingMethod">
          <el-tooltip v-if="storeInfo.platformCode === 'SP'" :content="$t('storeSetting.productRuleYHint4')" class="item" effect="dark" placement="bottom">
            <el-radio :label="3">{{ $t('PersonalCenter.Store.SetStore.orderCustomization') }}</el-radio>
          </el-tooltip>
          <el-radio :label="0">{{ $t('PersonalCenter.Store.SetStore.Standard') }}</el-radio>
          <el-radio :label="1">{{ $t('PersonalCenter.Store.SetStore.Express') }}</el-radio>
          <el-radio :label="2">{{ $t('PersonalCenter.Store.SetStore.Expedited') }}</el-radio>
        </el-radio-group>

        <div class="label font f--c">
          <div>When the store order phone number is empty, the default to</div>
          <el-input v-model.trim="phoneNumber" clearable :placeholder="$t('common.inputContent')" style="width:300px;margin-left:10px">
            <el-select v-model="areaCode" clearable filterable slot="prepend" style="color:000;width:100px">
              <el-option v-for="item in addressDataFilter" :label="item.areaCode" :value="item.areaCode" :key="item.countryCode+item.areaCode">{{item.areaCode}}({{ item.countryCode }})</el-option>
            </el-select>
          </el-input>
        </div>
      </div>
    </div>
    <div class="footer bg-white f-c-c">
      <el-button type="success" @click="setStore">{{  $t('storeSetting.save') }}</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { telephoneNumber, generalPhoneNumber } from '@/util/validate'
export default {
  data() {
    return {
      radio: '',
      currency: [],
      input: '',
      value: '',
      storeInfo: {
        isAutoPurchase: '',
        shippingMethod: '',
        isAutoInventory: '',
        autoDeleteSoldOutSku: [],
        listingUpdateConfList: [], // 变更字段配置
        isPrice: '',
        priceRatio: '',
        isDeliverMark: '',
        isComparePrice: '',
        compareRatio: '',
        isTax: '',
        defaultReceivingCountry: '',

        priceRatioType: 'x',
        compareRatioType: 'x'
      },
      receivingCountryList: [],
      receivingCountryListFilter: [],
      updateConfList: [], // 变更字段列表

      addressDataFilter: [],
      phoneNumber: '',
      areaCode: undefined
    }
  },
  created() {
    this.getStoreDetail()
    this.getSelectList(6)
    this.getSelectList(7)
    this.getSelectList(15)
    this.getAddressInfo()
  },
  methods: {
    getSelectList(type) {
      let form = { type }
      if (type === 7) form.param = 'G007'
      API.getSelectList(form).then(res => {
        if (type === 15) this.updateConfList = res.data || []
        else if (type === 6) this.currency = res.data.filter(item => { return item.code })
        else {
          this.receivingCountryList = res.data
          this.receivingCountryListFilter = this.receivingCountryList.slice()
        }
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    getStoreDetail() {
      API.getStoreDetail(this.$route.query.storeId).then(res => {
        this.storeInfo.authorizeStatus = res.data.authorizeStatus
        this.storeInfo.platformCode = res.data.platformCode
        this.storeInfo.platformName = res.data.platformName
        this.storeInfo.storeId = res.data.storeId
        this.storeInfo.currency = res.data.currency
        this.storeInfo.isTax = res.data.isTax !== undefined ? res.data.isTax : 0
        this.storeInfo.storeName = res.data.storeName
        this.storeInfo.storeStatus = res.data.storeStatus
        this.storeInfo.storeUrl = res.data.storeUrl
        this.storeInfo.userId = res.data.userId
        this.storeInfo.isAutoPurchase = res.data.isAutoPurchase !== undefined ? res.data.isAutoPurchase : 0
        this.storeInfo.shippingMethod = res.data.shippingMethod ? res.data.shippingMethod : 0
        // this.storeInfo.isAutoInventory = res.data.isAutoInventory !== undefined ? res.data.isAutoInventory : 1
        this.storeInfo.isAutoInventory = res.data.isAutoInventory !== undefined ? !!res.data.isAutoInventory : true
        // this.storeInfo.autoDeleteSoldOutSku = res.data.autoDeleteSoldOutSku !== undefined ? res.data.autoDeleteSoldOutSku : 1
        this.storeInfo.autoDeleteSoldOutSku = res.data.autoDeleteSoldOutSku !== undefined ? !!res.data.autoDeleteSoldOutSku : true
        this.storeInfo.listingUpdateConfList = res.data.listingUpdateConfList || []
        this.storeInfo.isPrice = res.data.isPrice !== undefined ? res.data.isPrice : 1
        this.storeInfo.isComparePrice = res.data.isComparePrice !== undefined ? res.data.isComparePrice : 0
        this.storeInfo.isDeliverMark = res.data.isDeliverMark !== undefined ? res.data.isDeliverMark : 1
        this.storeInfo.compareRatio = res.data.compareRatio
        this.storeInfo.priceRatio = res.data.priceRatio ? res.data.priceRatio : '1.5'
        this.storeInfo.priceRatioType = res.data.priceRatioType
        this.storeInfo.compareRatioType = res.data.compareRatioType
        if (res.data.storeOrderDefaultPhone) {
          let str = res.data.storeOrderDefaultPhone.split(' ')
          let num = ''
          this.areaCode = str[0]
          if (str.length > 2) {
            str.forEach((t, i) => {
              if (i === 1) num = t
              else if (i > 1) num = num + ' ' + t
            })
            this.phoneNumber = num
          } else {
            this.phoneNumber = str[1]
          }
        }
        this.phoneNumber
        // 双向绑定动态赋值
        this.$set(this.storeInfo, 'defaultReceivingCountry', res.data.defaultReceivingCountry || 'US')// 没有设置时默认选中美国
        this.$forceUpdate()
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },

    countryFilterMethod(searchValue) {
      if (!searchValue) {
        this.receivingCountryListFilter = this.receivingCountryList.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.receivingCountryList.forEach(e => {
          if (e.code.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.name.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          } else if (searchValue.toUpperCase() === 'UK' && e.name.toUpperCase().includes('ENGLAND')) {
            nameArr.push(e)
          }
        })
        this.receivingCountryListFilter = [...codeArr, ...nameArr]
      }
    },

    countrySelectChange() {
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    },

    filteredCountryList() {
      const keyword = this.storeInfo.defaultReceivingCountry // 输入的关键词
      if (!keyword) {
        return this.receivingCountryList // 如果没有输入关键词，返回全部列表
      } else {
        // 使用 filter 方法对国家列表进行模糊查询
        return this.receivingCountryList.filter(item => {
          return item.code.toLowerCase().includes(keyword.toLowerCase())
        })
      }
    },

    // 保存店铺设置
    setStore() {
      this.storeInfo.storeId = this.$route.query.storeId
      if (this.storeInfo.isComparePrice === 0) { this.storeInfo.compareRatio = '' }
      if (this.storeInfo.isPrice === 0) { this.storeInfo.priceRatio = '' }
      const storeInfo = _.cloneDeep(this.storeInfo)
      storeInfo.isAutoInventory = storeInfo.isAutoInventory ? 1 : 0
      storeInfo.autoDeleteSoldOutSku = storeInfo.autoDeleteSoldOutSku ? 1 : 0

      if (this.areaCode && !this.phoneNumber) {
        return this.$message.warning('Please input your phone number!')
      } else if (!this.areaCode && this.phoneNumber) {
        return this.$message.warning('Please input country code!')
      } else if (this.phoneNumber && !telephoneNumber(this.phoneNumber) && !generalPhoneNumber(this.phoneNumber)) {
        return this.$message.error('Please input valid phone number!')
      } else if (this.areaCode && this.phoneNumber) {
        storeInfo.storeOrderDefaultPhone = `${this.areaCode} ${this.phoneNumber}`
      } else {
        storeInfo.storeOrderDefaultPhone = ''
      }
      API.setStore(storeInfo).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('promptText.msg43'))
        this.$router.push('/personal-center/store-manage')
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },

    // 跳转外链
    jump() {
      window.open('https://www.youtube.com/watch?app=desktop&utm_source=BenchmarkEmail&utm_campaign=Shopify%E8%AE%BE%E7%BD%AE%E9%80%9A%E7%9F%A5&utm_medium=email&v=es8UCQNryB0&feature=youtu.be')
    },

    // 产品规则
    changeProductRules(e) {
      e && this.$set(this.storeInfo, 'isAutoInventory', true)
    },

    // 区号
    getAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.addressDataFilter = _.cloneDeep(res.data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#setting {
  font-family: Arial;
  // margin: 0 34px;
  min-height: 100vh;
  span {
    display: inline-block;
  }
}
.padding {
  padding: 28px 0 25px 44px;
}
.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 20px;
}
.footer {
  width: 100%;
  height: 80px;
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 1;
  box-shadow: 0px -2px 12px 2px rgba(0, 0, 0, 0.06);
}
.product-rule_1 {
  margin: 10px 0;
}
.product-rule_2 {
  margin-bottom: 10px;
}
.font {
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 18px;
}
.title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 20px;
}
.label {
  color: #747a87;
}
.info {
  color: #10141d;
}
.margin-l {
  display: inline-block;
  margin-left: 10px;
}
.priceCheckbox {
  padding: 16px 0 0 0;
  margin: 0 30px 0 0;
}
/deep/.el-button--success {
  border-color: none;
  border: none;
  background: #99c41c;
}
.main {
  /deep/ .el-input__inner {
    border-radius: 4px !important;
  }
}

</style>
